import { sharedRegex } from '@helpers/spread/shared-regex';
import { spreadsheetConfig } from '@shared/spreadsheet/spreadsheet-config';

// This values should match default values for each field.
// Type is mandatory to be an exact match of one of the categories or will not display the spreadsheet
const EMPTY_ROW_DEFAULT = {
  name: '',
  mnemonic: '',
  group_id: '',
  account_number: 0,
  description: '',
  display_format: 0,
  calculate_group: 0,
  simulation_order: 'pre-sim',
};

const config = {
  EXO_Accepted_Simulation_Order: ['', 'pre-sim', 'simulation', 'post-sim'],
  EXO_Accepted_Display_Format: ['', 'stock', 'flow', 'rate'],
  EXO_Accepted_Fail_Operator: ['', '<', '>'],
  EXO_Accepted_Display_In_Summary: ['Yes', 'No'],
  DEFAULT_RISK_LIMIT_VALUE: '0.00',
  EXO_Formatters: {
    riskLimit: '#,##0.00##',
    stock: '#,##0',
    flow: '#,##0.00',
    rate: '0.0000%',
  },
  MNEMONIC_REGEXP: sharedRegex.mnemonic,
  MINIMUM_ROWS: 50,
  EMPTY_ROW_DEFAULT,
  backColor: spreadsheetConfig.backColor, // '#F0F8FF'
  hostStyle: spreadsheetConfig.hostStyle,
  // Columns Setup
  columnsConfig: [
    { name: 'Name', displayName: 'Name', size: 160 },
    {
      name: 'Mnemonic',
      displayName: 'Mnemonic',
      size: 160,
    },
    { name: 'Group_ID', displayName: 'Group ID', size: 100 },
    {
      name: 'Account_Number',
      displayName: 'Account #',
      size: 100,
    },
    {
      name: 'Description',
      displayName: 'Description',
      size: 350,
    },
    {
      name: 'Display_Format',
      displayName: 'Display Format',
      size: 120,
    },
    {
      name: 'Calculate_Group',
      displayName: 'Calculate_Group',
      size: 140,
    },
    {
      name: 'Simulation_Order',
      displayName: 'Simulation Order',
      size: 140,
    },
    {
      name: 'Display_Order',
      displayName: 'Display Order',
      size: 90,
    },
    {
      name: 'Fail_Operator',
      displayName: 'Fail Operator',
      size: 90,
    },
    {
      name: 'Risk_Limit',
      displayName: 'Risk Limit',
      size: 90,
    },
    {
      name: 'Display_In_Summary',
      displayName: 'Display In Summary',
      size: 140,
    },
  ],
  DEFAULT_VALUES: {
    rowHeight: 20,
    colWidth: 150,
    fieldValue: 0,
    // spreadContentByDefault: [ EMPTY_ROW_DEFAULT ],
  },
  hLeftAlignStyle: spreadsheetConfig.align.left,
  hCenterAlignStyle: spreadsheetConfig.align.center,
  hRightAlignStyle: spreadsheetConfig.align.right,
};

export const SpreadConfig = config;

export function getExogenousDisplayFormat(displayFormat: string): string {
  switch (displayFormat) {
    case 'stock':
      return config.EXO_Formatters.stock;
    case 'flow':
      return config.EXO_Formatters.flow;
    case 'rate':
      return config.EXO_Formatters.rate;
  }
  return '';
}

export const COL_ACCOUNT_NAME = 0;
export const COL_MNEMONIC = 1;
export const COL_GROUP_ID = 2;
export const COL_ACCOUNT_NUM = 3;
export const COL_DESCRIPTION = 4;
export const COL_DISPLAY_FORMAT = 5;
export const COL_CALCULATE_GRP = 6;
export const COL_SIMULATION_ORDER = 7;
export const COL_DISPLAY_ORDER = 8;
export const COL_FAIL_OPERATOR = 9;
export const COL_RISK_LIMIT = 10;
export const COL_DISPLAY_IN_SUMMARY = 11;
